import { useCallback, useState } from "react"

export interface DetailListState {
	size: number
	isSettled: boolean
	/** The list really has nothing, rather than not having loaded yet. */
	isEmpty: boolean
	report: (size: number, isSettled: boolean) => void
}

export const useDetailListState = (): DetailListState => {
	const [state, setState] = useState({ size: 0, isSettled: false })

	const report = useCallback((size: number, isSettled: boolean) => {
		setState((prev) =>
			prev.size === size && prev.isSettled === isSettled
				? prev
				: { size, isSettled },
		)
	}, [])

	return {
		size: state.size,
		isSettled: state.isSettled,
		isEmpty: state.isSettled && state.size === 0,
		report,
	}
}
